import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEMediaCenterPropTypes, OEMediaCenterConfigFactory} from '../../controller/media-center/oe-media-center-model';
import OEMediaCenterItemCollection from '../../controller/media-center/components/oe-media-center-item-collection';

export class OEXRayIcarusSubItemView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.item = null;

        this.state = {
            uiEnabled: false,
            visible: false,
            item: [],
            subItems: [],
            selectedItemIndex: -1,
            itemHeight: undefined,
            subItemsHeight: undefined,
            strings: {
                itemLabel: '',
                subItemsLabel: ''
            }
        };

        this.mcItemCollectionConfig = {
            usePresItems: false,
            showIndex: false,
            showIcon: false,
            showLabel: false,
            showStats: false,
            noImages: false,
            noPresThumbImages: false
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onActualMediaCenterItemChanged = this.onActualMediaCenterItemChanged.bind(this);
        this.onActualMediaCenterSubItemChanged = this.onActualMediaCenterSubItemChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onItemContentResize = this.onItemContentResize.bind(this);
        this.onSubItemsContentResize = this.onSubItemsContentResize.bind(this);

        this.onItemClicked = this.onItemClicked.bind(this);
        this.onSubItemClicked = this.onSubItemClicked.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateUIState()   {
        if(!this.oe.isReady())  return;
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        this.setState({
            uiEnabled: controller.getUIEnabled()
        });
    }

    updateVisibleState() {
        if(!this.oe.isReady())  return;
        let visible = !!this.item && !!this.item.subItems.length && this.item.type === this.oe.Module.MediaCenterItemType.animation;
        this.setState({visible: visible});
    }

    updateItem()  {
        if(!this.oe.isReady())  return;
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();

        let id = controller.getActualMediaItemID();
        this.item = controller.mediaItemID(id, -1);

        this.setState({item: this.item ? [this.item] : [], subItems: this.item ? this.item.subItems : []});

        this.updateVisibleState();
        this.updateSelectedItemIndex();
        this.updateLanguage();
    }

    determineSelectedItemIndex()  {
        if(!this.oe.isReady() || !this.item)  return -1;

        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        let activeItemId = {id: controller.getActualMediaItemID(), subId: controller.getActualMediaSubItemID()};

        if(activeItemId.id !== this.item.id)  return -1;
        
        for(let i = 0; i < this.item.subItems.length; i++)  {
            if(this.item.subItems[i].id == activeItemId.subId)    return i;
        }

        return -1;
    }

    updateSelectedItemIndex()    {
        this.setState({selectedItemIndex: this.determineSelectedItemIndex()});
    }

    updateLanguage()    {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                itemLabel: this.item ? si.getLocalizedStringEnc(this.item.label) : '',
                subItemsLabel: si.getLocalizedStringEnc('xray_icarus_sub_items_view_sub_items_title') + ':'
            }
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.item = null;
            this.setState({
                uiEnabled: false,
                visible: false,
                item: [],
                subItems: [],
                selectedItemIndex: -1,
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateUIState();
            this.updateItem();
        });
    }

    onActualMediaCenterItemChanged()    {
        this.updateItem();
    }

    onActualMediaCenterSubItemChanged() {
        this.updateSelectedItemIndex();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.media_center) {
            this.updateUIState();
        }
    }

    renderView()    {
        if(!this.state.visible) return null;

        this.mcItemCollectionConfig.presPlayableFlags = this.props.mediaCenterConfig.presPlayableFlags;

        const subItemMCItemCollectionConfig = Object.assign({}, this.mcItemCollectionConfig);
        subItemMCItemCollectionConfig.forceShowIndex = true;

        let itemStyle = {height: this.state.itemHeight};
        let subItemsStyle = {height: this.state.subItemsHeight};

        return (
            <div
                className={'xray-icarus-sub-item-view ' + this.props.className}
                style={this.props.style}
            >

                <div className="item-label">
                    <span>{this.state.strings.itemLabel}</span>
                </div>

                <div className="item">
                    <OEMediaCenterItemCollection
                        moduleId={this.props.moduleId}
                        className="vertical-layout"
                        style={itemStyle}
                        config={this.mcItemCollectionConfig}
                        enabled={this.state.uiEnabled}
                        items={this.state.item}
                        selectedItemIndex={this.state.selectedItemIndex < 0 ? 0 : -1}
                        scrollbar={{
                            horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.none,
                            verticalTrackVisiblity:         CustomScrollbarTrackVisibility.always,
                        }}
                        onContentResize={this.onItemContentResize}
                        onClick={this.onItemClicked}
                    />
                </div>

                <div className="sub-items-label">
                    <span>{this.state.strings.subItemsLabel}</span>
                </div>

                <div className="sub-items">
                    <OEMediaCenterItemCollection
                        moduleId={this.props.moduleId}
                        className="vertical-layout"
                        style={subItemsStyle}
                        config={subItemMCItemCollectionConfig}
                        enabled={this.state.uiEnabled}
                        items={this.state.subItems}
                        selectedItemIndex={this.state.selectedItemIndex}
                        scrollbar={{
                            horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.none,
                            verticalTrackVisiblity:         CustomScrollbarTrackVisibility.always,
                        }}
                        onContentResize={this.onSubItemsContentResize}
                        onClick={this.onSubItemClicked}
                    />
                </div>

            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                {this.renderView()}
            </React.Fragment>
        );
    }

    onItemContentResize(size)   {
        this.setState({itemHeight: size.h});
    }

    onSubItemsContentResize(size)   {
        this.setState({subItemsHeight: size.h});
    }

    onItemClicked(index, id)   {
        if(!this.oe.isReady() || !this.item)  return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemSubItemID(this.item.id, -1);
    }

    onSubItemClicked(index, id)   {
        if(!this.oe.isReady() || !this.item)  return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemSubItemID(this.item.id, id);
    }
}

OEXRayIcarusSubItemView.defaultProps = {
    moduleId: '',
    className: '',
    mediaCenterConfig: OEMediaCenterConfigFactory.std(),
};

OEXRayIcarusSubItemView.propTypes = {
    moduleId: PropTypes.string,
    className: PropTypes.string,
    styles: PropTypes.object,
    mediaCenterConfig: OEMediaCenterPropTypes.configDecl,
};

export default frefFromRef(connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    const ret = {
        appComponent: env.component,
        mediaCenterConfig: ui.mediaCenter,
    };
    return ret;
})(frefToRef(OEXRayIcarusSubItemView)));